import { Map } from 'immutable';
import { LoadingStatusEnum } from '../../../../../lib/enums';
import { actionTypes } from '../../../../controller';

const {
	START_FETCH_CONVERSATION,
	FETCH_CONVERSATION_SUCCESS,
	FETCH_CONVERSATION_FAILED,

	START_CREATE_CONVERSATION,
	SELECT_CONVERSATION_SUCCESS,
	SELECT_CONVERSATION_FAILED,

	START_CREATE_NORMAL_REPLY_CONVERSATION,
	CREATE_NORMAL_REPLY_CONVERSATION_SUCCESS,
	CREATE_NORMAL_REPLY_CONVERSATION_FAILED,

	START_CREATE_QUICK_PATH_CONVERSATION,
	CREATE_QUICK_PATH_CONVERSATION_SUCCESS,
	CREATE_QUICK_PATH_CONVERSATION_FAILED,

	START_CREATE_SMART_REPLY_CONVERSATION,
	CREATE_SMART_REPLY_CONVERSATION_SUCCESS,
	CREATE_SMART_REPLY_CONVERSATION_FAILED,

	START_UPDATE_CONVERSATION_TEXT_SIZE,
	UPDATE_CONVERSATION_TEXT_SIZE_SUCCESS,
	UPDATE_CONVERSATION_TEXT_SIZE_FAILED,

	START_CLOSE_CONVERSATION,
	CLOSE_CONVERSATION_SUCCESS,
	CLOSE_CONVERSATION_FAILED,

	START_GRADE_CONVERSATION_SCORE,
	GRADE_CONVERSATION_SCORE_SUCCESS,
	GRADE_CONVERSATION_SCORE_FAILED,

	START_CLEAR_CONVERSATION_SESSION,
	CLEAR_CONVERSATION_SESSION_SUCCESS,
	CLEAR_CONVERSATION_SESSION_FAILED,

	CLEARED_CONVERSATION_SESSION_EVENT,

	UPDATE_CONVERSATION_STATUS,

	UPDATE_CONVERSATION_COLOR_MAPPING,

	UPDATE_CONVERSATION_TEXT_SIZE_EVENT,

	RESET_CONVERSATION,

	UPDATE_CONVERSATION,
} = actionTypes;
const {
	NONE,
	LOADING,
	SUCCESS,
	FAILED,
} = LoadingStatusEnum;
const initialState = Map({
	data: Map(),

	score: 0,
	scoreAt: '',

	isSessionBeCleared: false,
	isCloseConversationForNavigatingToHome: false,

	loadingStatus: NONE,
	loadingStatusMessage: '',

	createConversationLoadingStatus: NONE,
	createConversationLoadingStatusMessage: '',

	createNormalReplyConversationLoadingStatus: NONE,
	createNormalReplyConversationLoadingStatusMessage: '',

	createQuickPathConversationLoadingStatus: NONE,
	createQuickPathConversationLoadingStatusMessage: '',

	createSmartReplyConversationLoadingStatus: NONE,
	createSmartReplyConversationLoadingStatusMessage: '',

	updateConversationTextSizeLoadingStatus: NONE,
	updateConversationTextSizeLoadingStatusMessage: '',

	closeConversationLoadingStatus: NONE,
	closeConversationLoadingStatusMessage: '',

	gradeConversationLoadingStatus: NONE,
	gradeConversationLoadingStatusMessage: '',

	clearConversationLoadingStatus: NONE,
	clearConversationLoadingStatusMessage: '',
});

export default function conversation(state = initialState, action) {
	switch (action.type) {
		case START_FETCH_CONVERSATION:
			return state
				.set('loadingStatus', LOADING);

		case FETCH_CONVERSATION_SUCCESS:
			return state
				.set('data', Map(action.conversation))
				.set('loadingStatus', SUCCESS);

		case FETCH_CONVERSATION_FAILED:
			return state
				.set('loadingStatus', FAILED)
				.set('loadingStatusMessage', action.errorMessage);

		case START_CREATE_CONVERSATION:
			return state
				.set('createConversationLoadingStatus', LOADING);

		case SELECT_CONVERSATION_SUCCESS:
			return state
				.set('createConversationLoadingStatus', SUCCESS);

		case SELECT_CONVERSATION_FAILED:
			return state
				.set('createConversationLoadingStatus', FAILED)
				.set('createConversationLoadingStatusMessage', action.errorMessage);

		case START_CREATE_NORMAL_REPLY_CONVERSATION:
			return state
				.set('createNormalReplyConversationLoadingStatus', LOADING);

		case CREATE_NORMAL_REPLY_CONVERSATION_SUCCESS:
			return state
				.set('createNormalReplyConversationLoadingStatus', SUCCESS);

		case CREATE_NORMAL_REPLY_CONVERSATION_FAILED:
			return state
				.set('createNormalReplyConversationLoadingStatus', FAILED)
				.set('createNormalReplyConversationLoadingStatusMessage', action.errorMessage);

		case START_CREATE_QUICK_PATH_CONVERSATION:
			return state
				.set('createQuickPathConversationLoadingStatus', LOADING);

		case CREATE_QUICK_PATH_CONVERSATION_SUCCESS:
			return state
				.set('createQuickPathConversationLoadingStatus', SUCCESS);

		case CREATE_QUICK_PATH_CONVERSATION_FAILED:
			return state
				.set('createQuickPathConversationLoadingStatus', FAILED)
				.set('createQuickPathConversationLoadingStatusMessage', action.errorMessage);

		case START_CREATE_SMART_REPLY_CONVERSATION:
			return state
				.set('createSmartReplyConversationLoadingStatus', LOADING);

		case CREATE_SMART_REPLY_CONVERSATION_SUCCESS:
			return state
				.set('createSmartReplyConversationLoadingStatus', SUCCESS);

		case CREATE_SMART_REPLY_CONVERSATION_FAILED:
			return state
				.set('createSmartReplyConversationLoadingStatus', FAILED)
				.set('createSmartReplyConversationLoadingStatusMessage', action.errorMessage);

		case START_UPDATE_CONVERSATION_TEXT_SIZE:
			return state
				.set('updateConversationTextSizeLoadingStatus', LOADING);

		case UPDATE_CONVERSATION_TEXT_SIZE_SUCCESS:
			return state
				.updateIn(['data'], conversation => {
					const convertedConversation = conversation.toObject();

					if (convertedConversation.id === action.conversation.id) {
						return Map({ ...convertedConversation, textSize: action.conversation.textSize });
					}

					return Map(convertedConversation);
				})
				.set('updateConversationTextSizeLoadingStatus', SUCCESS);

		case UPDATE_CONVERSATION_TEXT_SIZE_FAILED:
			return state
				.set('updateConversationTextSizeLoadingStatus', FAILED)
				.set('updateConversationTextSizeLoadingStatusMessage', action.errorMessage);

		case START_CLOSE_CONVERSATION:
			return state
				.set('closeConversationLoadingStatus', LOADING)
				.set('isCloseConversationForNavigatingToHome', action.isNavigatingHome);

		case CLOSE_CONVERSATION_SUCCESS: {
			let nextState = state
				.update('data', conversation => {
					const convertedConversation = conversation.toObject();
					const { conversation: nextConversation = {} } = action;

					if (convertedConversation.id === nextConversation.id) {
						return Map({ ...convertedConversation, ...nextConversation });
					}

					return conversation;
				})
				.set('closeConversationLoadingStatus', SUCCESS);

			if (state.get('isCloseConversationForNavigatingToHome')) {
				nextState = nextState
					.set('isCloseConversationForNavigatingToHome', false)
					.set('loadingStatus', NONE);
			}

			return nextState;
		}

		case CLOSE_CONVERSATION_FAILED:
			return state
				.set('closeConversationLoadingStatus', FAILED)
				.set('closeConversationLoadingStatusMessage', action.errorMessage);

		case START_GRADE_CONVERSATION_SCORE:
			return state
				.set('gradeConversationLoadingStatus', LOADING);

		case GRADE_CONVERSATION_SCORE_SUCCESS:
			return state
				.set('score', action.score)
				.set('scoreAt', action.scoreAt)
				.setIn(['data', 'score'], action.score)
				.setIn(['data', 'scoreAt'], action.scoreAt)
				.set('gradeConversationLoadingStatus', SUCCESS);

		case GRADE_CONVERSATION_SCORE_FAILED:
			return state
				.set('gradeConversationLoadingStatus', FAILED)
				.set('gradeConversationLoadingStatusMessage', action.errorMessage);

		case START_CLEAR_CONVERSATION_SESSION:
			return state
				.set('clearConversationLoadingStatus', LOADING);

		case CLEAR_CONVERSATION_SESSION_SUCCESS:
			return state
				.set('clearConversationLoadingStatus', SUCCESS);

		case CLEAR_CONVERSATION_SESSION_FAILED:
			return state
				.set('clearConversationLoadingStatus', FAILED)
				.set('clearConversationLoadingStatusMessage', action.errorMessage);

		case CLEARED_CONVERSATION_SESSION_EVENT:
			return state
				.update('isSessionBeCleared', isSessionBeCleared => {
					const conversationId = state.getIn(['data', 'id']);

					if (action.conversationid === conversationId) {
						return true;
					}

					return isSessionBeCleared;
				});

		case UPDATE_CONVERSATION_STATUS:
			return state
				.update('data', conversation => {
					const convertedConversation = conversation.toObject();
					const { conversation: nextConversation = {} } = action;

					if (convertedConversation.id === nextConversation.id) {
						return Map({ ...convertedConversation, ...nextConversation });
					}

					return conversation;
				});

		case UPDATE_CONVERSATION_COLOR_MAPPING:
			return state
				.update('data', conversation => {
					const { data: { colorMapping, conversationId } = {} } = action;
					const prevConversationId = conversation.get('id');

					if (prevConversationId === conversationId) {
						const nextConversation = conversation.update(
							'colorMapping',
							prevColorMapping => colorMapping ?? prevColorMapping,
						);

						return nextConversation;
					}

					return conversation;
				});

		case UPDATE_CONVERSATION_TEXT_SIZE_EVENT:
			return state
				.update('data', conversation => {
					const { conversation: { textSize, id } = {} } = action;
					const prevConversationId = conversation.get('id');

					if (prevConversationId === id) {
						const nextConversation = conversation.update(
							'textSize',
							prevTextSize => textSize ?? prevTextSize,
						);

						return nextConversation;
					}

					return conversation;
				});

		case UPDATE_CONVERSATION:
			return state
				.update('data', conversation => Map({
					...conversation.toObject(),
					...action.conversation,
				}));

		case RESET_CONVERSATION:
			return initialState;

		default:
			return state;
	}
}
